import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChangePasswordDialogComponent } from './change-password-dialog.component';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { PasswordVisibilityToggleModule } from '@go-modules/directives/password-visibility-toggle/password-visibility-toggle.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { A11yModule } from '@angular/cdk/a11y';
import { GoDialogContentDirective } from '@go-modules/directives/go-dialog-content/go-dialog-content.directive';

@NgModule({
	imports: [
		CommonModule,
		MatTooltipModule,
		FormsModule,
		ReactiveFormsModule,
		TranslateModule,
		GoMaterialModule,
		PasswordVisibilityToggleModule,
		A11yModule,
		GoDialogContentDirective
	],
	declarations: [
		ChangePasswordDialogComponent
	],
	exports: [
		ChangePasswordDialogComponent
	]
})
export class ChangePasswordDialogModule {}
